import React from 'react'
import { connect } from "react-redux"
import { navigateTo } from 'gatsby-link'
import styled, { css, injectGlobal } from 'styled-components'
import { VelocityTransitionGroup } from 'velocity-react'
import Link from 'gatsby-link'
import { rgba } from 'polished'
import moment from 'moment'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { ScrollBackground } from '../' 

import arrowBack from '../../assets/icons/arrow-back.svg'
import logo from '../../assets/images/logo.png'
import logoBrown from '../../assets/images/logo-brown.png'
import burger from '../../assets/icons/burger.png'
import close from '../../assets/icons/close.png'

import { media, width, isClient } from '../../styles/utils'
import { container, padding, hoverState, headerHeight } from '../../styles/global'
import { grey, pageBackground } from '../../styles/colors';
import { caption } from '../../styles/type';
import { warmBrown } from '../../styles/themes';
import { fetchSettings, getSettings } from '../../store/settings'

let previousPosition = isClient() && window.pageYOffset || isClient() && document.documentElement.scrollTop;

class Header extends React.Component {

	state = {
		pageLoaded: false,
		navOpen: false,
		scrolled: false,
		phoneSticky: false
	}
	
	componentWillMount = () => {
		const { fadeIn } = this.props; 

		if (!fadeIn) { 
			this.setState({
				pageLoaded: true
			})
		}
	}
	
	componentDidMount() {
        const { fadeIn } = this.props;
		
		if (fadeIn) {
			// Animate load

			setTimeout(() => {
				this.setState({
					pageLoaded: true
				})
			}, 0)
		}

		window.addEventListener('scroll', this.handleScroll);
    }
    

    componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		clearAllBodyScrollLocks();
    }

    handleScroll = () => {
		// user scrolled past 40px from top of the page?
        if (window.pageYOffset >= 40) {
			this.setState({ scrolled: true });
			
			// user scrolling upwards? (phone only)
			if (width.phone()) {
				var currentPosition = window.pageYOffset || document.documentElement.scrollTop;

				if (previousPosition > currentPosition) {
					this.setState({ phoneSticky: true });
				} else {
					this.setState({ phoneSticky: false });
				}
				previousPosition = currentPosition;
			}
        } else {
			this.setState({ scrolled: false });
			this.setState({ phoneSticky: false });
		}
    }

    lockScroll = () => {
		const navMenu = document.querySelector('.nav-menu');

        if (this.state.navOpen == true) {
			disableBodyScroll(navMenu);
        } else {
			enableBodyScroll(navMenu);
        }
    }

    toggleNav = () => {
        const currentState = this.state.navOpen;

		this.setState({ navOpen: !currentState }, function() {
			// Lock scroll on body (mobile nav)
			if (width.tablet()) {
				this.lockScroll()
			}
		})
	}

	renderNav = () => {
        // const location = this.props.location.pathname

		return (
			<Nav>
				<NavLink
					to="/"
					onClick={() => this.toggleNav()}
				>
					Home
				</NavLink>

				<NavLink
					to="/casestudy"
					onClick={() => this.toggleNav()}
				>
					Case Study
				</NavLink>

				<NavLink
					to="/projects"
					onClick={() => this.toggleNav()}
				>
					Projects
				</NavLink>

				<NavLink
					to="/journal"
					onClick={() => this.toggleNav()}
				>
					Journal
				</NavLink>

				<NavLink
					to="/profile"
					onClick={() => this.toggleNav()}
				>
					Profile
				</NavLink>

				<NavLink
					to="/contact"
					onClick={() => this.toggleNav()}
				>
					Contact
				</NavLink>
			</Nav>
		)
	}

	renderDesktopNav = () => {
		const { settings } = this.props;

		return (
			<DesktopNav
				className={'nav-menu'}
				// theme={settings.theme}
			>
				{this.renderNav()}
			</DesktopNav>
		)
	}
	
	renderMobileNav = () => {		
		const year = moment().year();
		const copyright_credits = `© Paul Conrad Architects ${year}<br/>
		Website by <a href="http://three60.com.au" target="_blank">Three60</a> & <a href="https://www.studiopda.com.au/" target="_blank">PDA</a>`

		return (
			<MobileNav
				className={'nav-menu'}
			>
				<Logo src={logoBrown} onClick={() => navigateTo('/')}/>

				{this.renderNav()}

				<CopyrightCredits
					dangerouslySetInnerHTML={{__html: copyright_credits}}  
				/>
			</MobileNav>
		)
    }
	
	render() {
		const { pageLoaded, navOpen, scrolled, phoneSticky } = this.state;
		const { scrollToRef, fadeIn, settings } = this.props;        
		const isHomepage = isClient() && location.pathname === '/';
		const isNotHomepage = isClient() && location.pathname !== '/';

		return (
			<React.Fragment>

				{/* Default Header */}

				<Container
					isHome={isHomepage}
					id='header'
				>
					<Arrow
						src={arrowBack}
                        onClick={() => isClient() && window.history.back()}
						isNotHomepage={isNotHomepage}
					/>

					<VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
						{!this.state.scrolled ? <Logo src={logoBrown} onClick={() => navigateTo('/')} inHeader={true}/> : undefined}
					</VelocityTransitionGroup>

					{/* Desktop Nav */}
					<VelocityTransitionGroup enter={{animation: { translateY: 0}, duration: '300'}} leave={{animation: {translateY: '-100%'}, duration: '300'}}>
						{this.state.navOpen && !width.tablet() ? this.renderDesktopNav() : undefined}
					</VelocityTransitionGroup>

					{/* Desktop Nav Overlay*/}
					<VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
						{this.state.navOpen && !width.tablet() ? <Overlay onClick={() => this.toggleNav()}/> : undefined}
					</VelocityTransitionGroup>

					{/* Mobile Nav */}
					<VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
						{this.state.navOpen && width.tablet() ? this.renderMobileNav() : undefined}
					</VelocityTransitionGroup>

					{!navOpen &&
						<BurgerIcon src={burger} onClick={() => this.toggleNav()}/>
					}

					{navOpen &&
						<CloseIcon 
							src={close} 
							onClick={() => this.toggleNav()}
							id='headerLogo'
						/>
					}
				</Container>

				{/* Sticky Mobile Header */}
				
				<VelocityTransitionGroup enter={{animation: { translateY: 0}, duration: '300'}} leave={{animation: {translateY: '-100%'}, duration: '300'}}>
					{phoneSticky ?
						<Container
							sticky={phoneSticky}
							open={navOpen}
							isHome={isHomepage}
							id={'mobile-sticky-header'}
							theme={settings.theme}
						>
							<Arrow
								src={arrowBack}
								onClick={() => navigateTo('/')}
								isNotHomepage={isNotHomepage}
							/>

							<ScrollBackground
								location={isClient() && window.location}
							/>

							{!navOpen &&
								<BurgerIcon src={burger}onClick={() => this.toggleNav()}/>
							}

							{navOpen &&
								<CloseIcon src={close} onClick={() => this.toggleNav()}/>
							}
						</Container>
						: undefined
					}
				</VelocityTransitionGroup>

			</React.Fragment>
		)
	}
}


// shared

const Logo = styled.img`
	width: 250px;
	height: auto;
	cursor: pointer;

	/* is in the header */
	${props => {
		if (props.inHeader) return css`
			position: fixed;
			top: 10rem;
			left: 0;
			right: 0;
			margin-left: auto;
			margin-right: auto;
			${hoverState};

			${media.phone`
				top: 43px;
				width: 180px;
			`}
		`
	}}
`

const BurgerIcon = styled.img`
	width: 20px;
	height: auto;
`

const CloseIcon = styled.img`
	width: 18px;
	height: auto;
`
const Arrow = styled.img`
	display: none;

	${props => {
		if (props.isNotHomepage) return css`
			display: flex;
		`
	}}
`


// Header (desktop and mobile)

const DesktopNav = styled.div`
	background: ${props => props.theme.background} !important;
	transition: background 0.15s ease;

	* {
		color: ${props => props.theme.text} !important;
		transition: colour 0.15s ease;
	}
`
const Overlay = styled.div``
const Nav = styled.div``
const NavLink = styled(Link)``

const Container = styled.div`
	height: ${headerHeight.desktop}px;

	${media.laptop`
		height: ${headerHeight.laptop}px;

		&#mobile-sticky-header {
			z-index: 7;
		}
	`}

	&, ${DesktopNav} {
		z-index: 8;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10rem 10rem 0;
		box-sizing: border-box;
	}

	${Overlay} {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100vh;
		background: rgba(217, 217, 217, 0.5);
	}

	/* Icons */

	${BurgerIcon}, ${CloseIcon}, ${Arrow} {
		z-index: 10;
		position: fixed;
		top: 10rem;
		opacity: 0.5;
		cursor: pointer;
		transition: 0.15s opacity ease;


		&:hover {
			opacity: 1;
		}

		${media.phone`
			top: 40px;
		`}
	}

	${BurgerIcon}, ${CloseIcon} {
		right: 10rem;
		margin-top: 2px;

		${media.phone`
			margin-top: 0;
			right: 40px;
		`}
	}

	${Arrow} {
		left: 10rem;

		${media.tablet`
			z-index: initial;
		`}

		${media.phone`
			left: 40px;
		`}
	}


	/* Desktop Nav Menu */
	${DesktopNav} {
		background: ${pageBackground};

		${media.tablet`
			display: none;
		`}

		${Nav} {
			display: flex;
			flex-direction: row;
			justify-content: center;
			width: 100%;
			padding-bottom: 10rem;

			${NavLink} {
				display: flex;
				font-family: 'Scto';
				font-weight: 300;
				font-size: 20px;
				line-height: 20px;
				opacity: 0.5;
				color: ${grey};
				cursor: pointer;
				transition: 0.15s opacity ease;

				&:hover {
					opacity: 1;
				}

				&:not(:last-child) {
					margin-right: 5rem;
				}
			}
		}
	}


	/* Sticky Phone Header */
	${media.phone`
		position: absolute;
		height: ${headerHeight.phone}px;

		background: ${props => props.theme.background} !important;
		transition: background 0.15s ease;

		* {
			color: ${props => props.theme.text} !important;
			transition: colour 0.15s ease;
		}

		${props => {
			if (props.sticky) return css`
				position: fixed;
			`
		}}

		${props => {
			if (!props.sticky) return css`
				${BurgerIcon}, ${Arrow} {
					position: absolute;
				}
			`
		}}

		${props => {
			if (props.sticky && !props.open) return css`
				height: ${headerHeight.phoneSticky}px;
				border-bottom: 1px solid rgba(0, 0, 0, 0.08);
				background-color: ${pageBackground};

				${BurgerIcon}, ${Arrow} {
					top: 32px;
				}
			`
		}}

		${props => {
			if (props.sticky && props.open) return css`
				${Arrow} {
					display: none;
				}
			`
		}}
	`}
`

// Mobile Nav Menu
const CopyrightCredits = styled.div``

const MobileNav = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	flex-direction: column;
	padding: 10rem;
	background-color: ${warmBrown.background};

	display: none;

	${media.tablet`
		display: flex;
	`}

	${media.phone`
		padding: 40px;
	`}

	${Nav} {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-top: 200px;

		${media.phone`
			margin-top: 120px;
		`}

		${NavLink} {
			display: flex;
			font-family: 'Scto';
			font-weight: 300;
			font-size: 22px;
			line-height: 24px;
			color: ${warmBrown.text};
			cursor: pointer;
			transition: 0.15s opacity ease;

			&:not(:first-child) {
				margin-top: 16px;
			}
		}
	}

	${CopyrightCredits} {
		position: absolute;
		bottom: 10rem;
		left: 10rem;
		${caption};
		color: rgba(77, 64, 46, 0.5);
		text-indent: 0 !important;
		margin-top: auto;

		${media.phone`
			bottom: 40px;
			left: 40px;
		`}

		a {
			color: rgba(77, 64, 46, 0.5);
			opacity: 1;
		}
	}
`

// Header always visible (splash removed)

injectGlobal`
	#header {
		display: block;
	}
`

const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/header.js